import type { TagCategory, TagSelections } from './types';

// -- Types matching Tag Service OpenAPI spec --

export interface TagServiceCategoriesResponse {
  categories: { name: string; tags: string[] }[];
}

export interface TagServiceUserTagsResponse {
  userId: string;
  tags: Record<string, string>;
}

export interface TagServiceSetUserTagsRequest {
  tags: Record<string, string>;
}

// -- Mappers --

export const mapCategoriesFromTagService = (response: TagServiceCategoriesResponse): TagCategory[] =>
  response.categories.map((c) => ({
    name: c.name,
    isSingleSelection: true, // All tag categories are single-selection; the Tag Service has no multi-select concept
    tags: c.tags,
  }));

export const mapUserTagsFromTagService = (response: TagServiceUserTagsResponse): TagSelections =>
  Object.fromEntries(Object.entries(response.tags).map(([key, value]) => [key, [value]]));

export const mapUserTagsToTagService = (selections: TagSelections): TagServiceSetUserTagsRequest => ({
  tags: Object.fromEntries(
    Object.entries(selections)
      .filter(([, values]) => values.length > 0)
      .map(([key, values]) => [key, values[0]])
  ),
});
